module.exports = "../../map/Tokyo/map/agriculture/Tokyo_AgricultureOrange_CMIP5RCP26_MIROC_No_R2081_2100.png";